import { IFeatureFlags, ISelfServiceMigrationFlags } from './common';
import flagsData from './flags';
import { FeatureFlagsHelper } from '@telstra-connect/feature-flags'
import { ApplicationName } from '../activity-tracking';

let helper: FeatureFlagsHelper<typeof ApplicationName>;

export const loadFeatureFlags = (getFlagsConfigFromState?: () => ISelfServiceMigrationFlags): void => {
    helper = new FeatureFlagsHelper(ApplicationName, getFlagsConfigFromState, flagsData)
};

export const getSSMFlags = (): IFeatureFlags => helper && helper.getFlags();
